import { createBrowserRouter, isRouteErrorResponse, Navigate, useRouteError } from 'react-router'
import { ConsoleLayout } from './routes/ConsoleLayout'
import { InvitesPage } from './routes/InvitesPage'
import { NotFoundPage } from './routes/NotFoundPage'
import { QueuePage } from './routes/QueuePage'
import { SignInPage } from './routes/SignInPage'
import { UsersPage } from './routes/UsersPage'

function RootErrorBoundary() {
  const error = useRouteError()
  if (isRouteErrorResponse(error)) {
    return (
      <div role="alert" className="flex min-h-dvh flex-col items-center justify-center gap-2 px-6 text-center">
        <h1 className="text-title font-semibold text-ink">
          {error.status} {error.statusText}
        </h1>
        <p className="text-ui text-muted">{typeof error.data === 'string' ? error.data : 'Request failed.'}</p>
      </div>
    )
  }
  return (
    <div role="alert" className="flex min-h-dvh flex-col items-center justify-center gap-2 px-6 text-center">
      <h1 className="text-title font-semibold text-ink">Something went wrong</h1>
      <p className="text-ui text-muted">{error instanceof Error ? error.message : 'Unknown error'}</p>
    </div>
  )
}

export const router = createBrowserRouter([
  {
    path: '/',
    Component: ConsoleLayout,
    ErrorBoundary: RootErrorBoundary,
    children: [
      // The queue is the console's reason to exist: signing in lands on it.
      { index: true, element: <Navigate to="/queue" replace /> },
      { path: 'queue', Component: QueuePage },
      { path: 'users', Component: UsersPage },
      { path: 'invites', Component: InvitesPage },
      { path: '*', Component: NotFoundPage },
    ],
  },
  { path: '/login', Component: SignInPage, ErrorBoundary: RootErrorBoundary },
])
